import Label, { LabelProps } from '../Label';

interface FormLabelProps extends LabelProps {}

export default function FormLabel({
  children,
  className = '',
  ...rest
}: FormLabelProps) {
  return (
    <Label className={`form-label ${className}`} {...rest}>
      {children}
    </Label>
  );
}
